// src/components/RechazarTareaModal.js

import React, { useState } from 'react';
import Button from './Button';

function RechazarTareaModal({ tareaTitulo, onClose, onConfirmarRechazo }) {
  const [comentario, setComentario] = useState('');

  const handleConfirmar = () => {
    onConfirmarRechazo(comentario);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-md">
        <h2 className="text-2xl font-bold text-principal mb-4">Rechazar Tarea</h2>
        <p className="mb-4 text-gray-600">
          Vas a devolver la tarea <span className="font-bold">"{tareaTitulo}"</span>. Puedes añadir un comentario para que el niño sepa qué corregir.
        </p>
        
        <textarea
          value={comentario}
          onChange={(e) => setComentario(e.target.value)}
          placeholder="Ej: ¡Casi! No te olvides de limpiar debajo de la cama."
          className="w-full h-24 px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-principal"
        />
        
        <div className="flex justify-end gap-4 mt-6">
          <Button type="button" variant="secondary" onClick={onClose}>
            Cancelar
          </Button>
          <Button type="button" variant="danger" onClick={handleConfirmar}>
            Confirmar Rechazo
          </Button>
        </div>
      </div>
    </div>
  );
}

export default RechazarTareaModal;